import { dataBullseye } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBullseye = /*#__PURE__*/createIcon(dataBullseye)
export default IconBullseye
